import { InputContainer } from './InputContainer';

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function InputContainerGroup(props: { children: JSX.Element[]; size?: 'small' | 'medium' | 'large' | 'auto' }) {
    return (
        <>
            {props.children.map((child, index) => (
                <InputContainer
                    key={index}
                    size={props.size}
                >
                    {child}
                </InputContainer>
            ))}
        </>
    );
}
